/* Picks Shop · patrón de Asas en 3D tras la foto del hero (Three.js r128). Si no hay WebGL, la foto queda sola sobre blanco. */
(function () {
  'use strict';

  var canvas = document.querySelector('[data-ps-asa-canvas]');
  if (!canvas || canvas.__psAsa) return;
  canvas.__psAsa = true;

  var hero = canvas.closest('[data-ps-hero]') || canvas.parentNode;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  var THREE_SRC = canvas.getAttribute('data-three') || 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';

  function fail() { hero.classList.add('ps-no-webgl'); }

  function hasWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
    } catch (e) { return false; }
  }
  if (!hasWebGL()) { fail(); return; }

  function boot() {
    if (window.THREE) { start(); return; }
    var s = document.createElement('script');
    s.src = THREE_SRC;
    s.async = true;
    s.onload = start;
    s.onerror = fail;
    document.head.appendChild(s);
  }
  // Carga Three cuando el navegador está libre para no competir con el primer pintado.
  if ('requestIdleCallback' in window) { window.requestIdleCallback(boot, { timeout: 600 }); } else { setTimeout(boot, 120); }

  function start() {
    var THREE = window.THREE;
    if (!THREE) { fail(); return; }

    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
    } catch (e) { fail(); return; }
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, coarse ? 1.75 : 2));

    var FOV = 28, CAM_Z = 50, PATTERN_Z = -9;
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(FOV, 1, 1, 200);
    camera.position.set(0, 0, CAM_Z);

    /* ---------- Geometría del Asa: semicírculo con remates rectos y puntas redondas ---------- */
    var U = 1;            // grosor = 1/11 del ancho total
    var R = 5 * U;        // radio de la línea central (ancho total = 2R + U = 11 U)
    var L = 0.85 * U;     // largo de los remates rectos
    var TUBE = 0.5 * U;   // radio del tubo

    function mergeGeos(list) {
      var vc = 0, ic = 0, i, g;
      for (i = 0; i < list.length; i++) { vc += list[i].attributes.position.count; ic += list[i].index.count; }
      var pos = new Float32Array(vc * 3), nor = new Float32Array(vc * 3), idx = new Uint16Array(ic);
      var vo = 0, io = 0, k, ia;
      for (i = 0; i < list.length; i++) {
        g = list[i];
        pos.set(g.attributes.position.array, vo * 3);
        nor.set(g.attributes.normal.array, vo * 3);
        ia = g.index.array;
        for (k = 0; k < ia.length; k++) idx[io + k] = ia[k] + vo;
        vo += g.attributes.position.count;
        io += ia.length;
      }
      var out = new THREE.BufferGeometry();
      out.setAttribute('position', new THREE.BufferAttribute(pos, 3));
      out.setAttribute('normal', new THREE.BufferAttribute(nor, 3));
      out.setIndex(new THREE.BufferAttribute(idx, 1));
      return out;
    }

    function asaGeometry() {
      var pts = [], i, a, n1 = 14, n2 = 120;
      for (i = 0; i <= n1; i++) pts.push(new THREE.Vector3(-R, L - L * i / n1, 0));
      for (i = 1; i <= n2; i++) { a = Math.PI + Math.PI * i / n2; pts.push(new THREE.Vector3(R * Math.cos(a), R * Math.sin(a), 0)); }
      for (i = 1; i <= n1; i++) pts.push(new THREE.Vector3(R, L * i / n1, 0));
      var curve = new THREE.CatmullRomCurve3(pts, false, 'centripetal');
      var tube = new THREE.TubeGeometry(curve, 240, TUBE, 22, false);
      var c1 = new THREE.SphereGeometry(TUBE, 22, 14); c1.translate(-R, L, 0);
      var c2 = new THREE.SphereGeometry(TUBE, 22, 14); c2.translate(R, L, 0);
      var g = mergeGeos([tube, c1, c2]);
      g.translate(0, -(L - R) / 2, 0);
      tube.dispose(); c1.dispose(); c2.dispose();
      return g;
    }

    var geo = asaGeometry();

    /* ---------- Patrón tono sobre tono (filas juntas) ---------- */
    var patMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
    var pattern = null, items = [], dummy = new THREE.Object3D();
    var toneA = new THREE.Color(0xF1EEE8), toneB = new THREE.Color(0xEBE8E0), white = new THREE.Color(0xffffff), tmpC = new THREE.Color();

    function buildPattern(visW, visH) {
      var colW = coarse ? 9.6 : 11.6, rowH = colW * 0.5;
      var cols = Math.ceil(visW / colW) + 2, rows = Math.ceil(visH / rowH) + 2;
      var count = cols * rows;
      if (pattern && pattern.count === count && pattern.userData.colW === colW) return;
      if (pattern) { scene.remove(pattern); pattern.dispose && pattern.dispose(); }
      pattern = new THREE.InstancedMesh(geo, patMat, count);
      pattern.userData.colW = colW;
      items = [];
      var i = 0, r, c;
      for (r = 0; r < rows; r++) {
        for (c = 0; c < cols; c++) {
          var x = (c - (cols - 1) / 2) * colW + (r % 2 ? colW / 2 : 0);
          var y = (r - (rows - 1) / 2) * rowH;
          items.push({ x: x, y: y, ph: (c * 1.7 + r * 2.3), ry: 0, vy: 0, rx: 0, vx: 0 });
          var fade = visW / visH >= 1.1 ? 1 - (x + visW / 2) / (visW * 0.62) : ((-y) + visH * 0.1) / (visH * 0.5);
          fade = Math.max(0, Math.min(1, fade));
          tmpC.copy(((r + c) % 2) ? toneA : toneB).lerp(white, 0.82 * fade);
          pattern.setColorAt(i, tmpC);
          i++;
        }
      }
      pattern.instanceColor.needsUpdate = true;
      pattern.position.z = PATTERN_Z;
      pattern.userData.s = 0.62;
      scene.add(pattern);
    }

    /* ---------- Tamaño y composición ---------- */
    var W = 0, H = 0, visW = 0, visH = 0;
    function resize() {
      var p = canvas.parentNode;
      var w = Math.max(1, Math.round(p.clientWidth)), h = Math.max(1, Math.round(p.clientHeight));
      if (w === W && h === H) return;
      W = w; H = h;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      visH = 2 * CAM_Z * Math.tan(THREE.MathUtils.degToRad(FOV / 2));
      visW = visH * camera.aspect;
      var k = (CAM_Z - PATTERN_Z) / CAM_Z;
      buildPattern(visW * k, visH * k);
      if (!running || reduced) draw(performance.now());
    }

    /* ---------- Puntero, scroll y clic ---------- */
    var nx = 0, ny = 0, tnx = 0, tny = 0, inside = false;
    function onMove(e) {
      if (e.pointerType === 'touch') return;
      var r = hero.getBoundingClientRect();
      tnx = Math.max(-1.3, Math.min(1.3, ((e.clientX - r.left) / r.width) * 2 - 1));
      tny = Math.max(-1.3, Math.min(1.3, -(((e.clientY - r.top) / r.height) * 2 - 1)));
      inside = e.clientY >= r.top - 80 && e.clientY <= r.bottom + 80;
    }
    if (!reduced) {
      window.addEventListener('pointermove', onMove, { passive: true });
      document.addEventListener('mouseleave', function () { tnx = 0; tny = 0; inside = false; });
    }

    /* ---------- Dibujo ---------- */
    var running = false, last = 0;
    function update(t, dt) {
      var f = reduced ? 1 : Math.min(1, dt * 60);
      nx += (tnx - nx) * 0.075 * f;
      ny += (tny - ny) * 0.075 * f;

      if (!pattern) return;
      var k = (CAM_Z - PATTERN_Z) / CAM_Z;
      var px = nx * (visW * k) / 2, py = ny * (visH * k) / 2;
      var ps = pattern.userData.s, i, it, dx, dy, d2, inf, tryy, trxx;
      for (i = 0; i < items.length; i++) {
        it = items[i];
        dx = px - it.x; dy = py - it.y;
        d2 = dx * dx + dy * dy;
        inf = (!reduced && inside) ? Math.exp(-d2 / 52) : 0;
        tryy = (reduced ? 0 : Math.sin(t * 0.6 + it.ph) * 0.16) + inf * (dx > 0 ? -1.5 : 1.5);
        trxx = (reduced ? 0 : Math.cos(t * 0.5 + it.ph) * 0.06) + inf * dy * 0.05;
        it.vy += (tryy - it.ry) * 0.11 * f; it.vy *= 0.8;
        it.vx += (trxx - it.rx) * 0.11 * f; it.vx *= 0.8;
        it.ry += it.vy * f; it.rx += it.vx * f;
        dummy.position.set(it.x, it.y, 0);
        dummy.rotation.set(it.rx, it.ry, 0);
        var s = ps * (1 + inf * 0.12);
        dummy.scale.set(s, s, s);
        dummy.updateMatrix();
        pattern.setMatrixAt(i, dummy.matrix);
      }
      pattern.instanceMatrix.needsUpdate = true;
    }

    function draw(now) {
      var t = now / 1000, dt = Math.min((now - last) / 1000, 0.05) || 0.016;
      last = now;
      update(t, dt);
      renderer.render(scene, camera);
    }

    function frame(now) {
      if (!running) return;
      requestAnimationFrame(frame);
      draw(now);
    }
    function play() { if (running || reduced) return; running = true; last = performance.now(); requestAnimationFrame(frame); }
    function stop() { running = false; }

    resize();
    draw(performance.now());
    hero.classList.add('is-3d');
    window.__psAsa = { ready: true };

    if ('ResizeObserver' in window) { new ResizeObserver(resize).observe(canvas.parentNode); } else { window.addEventListener('resize', resize); }

    if (!reduced) {
      var inView = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { inView = en[0].isIntersecting; (inView && !document.hidden) ? play() : stop(); }, { threshold: 0 }).observe(hero);
      } else { play(); }
      document.addEventListener('visibilitychange', function () { (document.hidden || !inView) ? stop() : play(); });
    }
    canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); stop(); fail(); hero.classList.remove('is-3d'); });
  }
})();
